// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.wizard.LeaseWizardWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseWizardWebApiHandler_getFirstNodeInSectionCategory,
  LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_Path,
  LeaseWizardWebApiHandler_getLeaseStatus,
  LeaseWizardWebApiHandler_getLeaseStatus_Path,
  LeaseWizardWebApiHandler_getLeaseStatusForNode,
  LeaseWizardWebApiHandler_getLeaseStatusForNode_Path,
  LeaseWizardWebApiHandler_getNextNode,
  LeaseWizardWebApiHandler_getNextNode_Path,
  LeaseWizardWebApiHandler_getPreviousNode,
  LeaseWizardWebApiHandler_getPreviousNode_Path,
  LeaseWizardWebApiHandler_reevaluateLeaseCompletion,
  LeaseWizardWebApiHandler_submitData,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetFirstNodeInSectionCategoryResponseDto,
  GetLeaseStatusForNodeResponseDto,
  GetLeaseStatusWebApiResponseDto,
  GetNextNodeResponseDto,
  GetPreviousNodeResponseDto,
  ReevaluateLeaseCompletionRequestDto,
  ReevaluateLeaseCompletionWebApiResponseDto,
  SubmitDataRequestDto,
  SubmitDataResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface GetFirstNodeInSectionCategoryParams {
  leaseId: number;
  sectionCategory: string;
}
interface GetLeaseStatusParams {
  leaseId: number;
}
interface GetLeaseStatusForNodeParams {
  leaseId: number;
  nodeId: number;
}
interface GetNextNodeParams {
  currentNodeId: number;
  leaseId: number;
}
interface GetPreviousNodeParams {
  currentNodeId: number;
  leaseId: number;
}

export type LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_Options = UseQueryOptions<
  GetFirstNodeInSectionCategoryResponseDto,
  unknown,
  GetFirstNodeInSectionCategoryResponseDto,
  Array<string | GetFirstNodeInSectionCategoryParams>
>;

const LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_GetKey = (
  getParams: GetFirstNodeInSectionCategoryParams,
) => [LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_Path, getParams];

/**
 * get the first node given a section category string
 */
export const useLeaseWizardWebApiHandler_getFirstNodeInSectionCategory = (
  getParams: GetFirstNodeInSectionCategoryParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_GetKey(getParams),
    queryFn: () => LeaseWizardWebApiHandler_getFirstNodeInSectionCategory(getParams, httpClient),
  });
};
useLeaseWizardWebApiHandler_getFirstNodeInSectionCategory.getKey =
  LeaseWizardWebApiHandler_getFirstNodeInSectionCategory_GetKey;

export type LeaseWizardWebApiHandler_getLeaseStatus_Options = UseQueryOptions<
  GetLeaseStatusWebApiResponseDto,
  unknown,
  GetLeaseStatusWebApiResponseDto,
  Array<string | GetLeaseStatusParams>
>;

const LeaseWizardWebApiHandler_getLeaseStatus_GetKey = (getParams: GetLeaseStatusParams) => [
  LeaseWizardWebApiHandler_getLeaseStatus_Path,
  getParams,
];

/**
 * get status of lease creation
 */
export const useLeaseWizardWebApiHandler_getLeaseStatus = (
  getParams: GetLeaseStatusParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseWizardWebApiHandler_getLeaseStatus_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseWizardWebApiHandler_getLeaseStatus_GetKey(getParams),
    queryFn: () => LeaseWizardWebApiHandler_getLeaseStatus(getParams, httpClient),
  });
};
useLeaseWizardWebApiHandler_getLeaseStatus.getKey = LeaseWizardWebApiHandler_getLeaseStatus_GetKey;

export type LeaseWizardWebApiHandler_getLeaseStatusForNode_Options = UseQueryOptions<
  GetLeaseStatusForNodeResponseDto,
  unknown,
  GetLeaseStatusForNodeResponseDto,
  Array<string | GetLeaseStatusForNodeParams>
>;

const LeaseWizardWebApiHandler_getLeaseStatusForNode_GetKey = (getParams: GetLeaseStatusForNodeParams) => [
  LeaseWizardWebApiHandler_getLeaseStatusForNode_Path,
  getParams,
];

/**
 * get the lease status with regard to a specific node
 */
export const useLeaseWizardWebApiHandler_getLeaseStatusForNode = (
  getParams: GetLeaseStatusForNodeParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseWizardWebApiHandler_getLeaseStatusForNode_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseWizardWebApiHandler_getLeaseStatusForNode_GetKey(getParams),
    queryFn: () => LeaseWizardWebApiHandler_getLeaseStatusForNode(getParams, httpClient),
  });
};
useLeaseWizardWebApiHandler_getLeaseStatusForNode.getKey = LeaseWizardWebApiHandler_getLeaseStatusForNode_GetKey;

export type LeaseWizardWebApiHandler_getNextNode_Options = UseQueryOptions<
  GetNextNodeResponseDto,
  unknown,
  GetNextNodeResponseDto,
  Array<string | GetNextNodeParams>
>;

const LeaseWizardWebApiHandler_getNextNode_GetKey = (getParams: GetNextNodeParams) => [
  LeaseWizardWebApiHandler_getNextNode_Path,
  getParams,
];

/**
 * get the current status of the next node
 */
export const useLeaseWizardWebApiHandler_getNextNode = (
  getParams: GetNextNodeParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseWizardWebApiHandler_getNextNode_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseWizardWebApiHandler_getNextNode_GetKey(getParams),
    queryFn: () => LeaseWizardWebApiHandler_getNextNode(getParams, httpClient),
  });
};
useLeaseWizardWebApiHandler_getNextNode.getKey = LeaseWizardWebApiHandler_getNextNode_GetKey;

export type LeaseWizardWebApiHandler_getPreviousNode_Options = UseQueryOptions<
  GetPreviousNodeResponseDto,
  unknown,
  GetPreviousNodeResponseDto,
  Array<string | GetPreviousNodeParams>
>;

const LeaseWizardWebApiHandler_getPreviousNode_GetKey = (getParams: GetPreviousNodeParams) => [
  LeaseWizardWebApiHandler_getPreviousNode_Path,
  getParams,
];

/**
 * get the current status of the previous node
 */
export const useLeaseWizardWebApiHandler_getPreviousNode = (
  getParams: GetPreviousNodeParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseWizardWebApiHandler_getPreviousNode_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseWizardWebApiHandler_getPreviousNode_GetKey(getParams),
    queryFn: () => LeaseWizardWebApiHandler_getPreviousNode(getParams, httpClient),
  });
};
useLeaseWizardWebApiHandler_getPreviousNode.getKey = LeaseWizardWebApiHandler_getPreviousNode_GetKey;

export interface LeaseWizardWebApiHandler_reevaluateLeaseCompletion_Args {
  postData: ReevaluateLeaseCompletionRequestDto;
}

export type LeaseWizardWebApiHandler_reevaluateLeaseCompletion_Options = UseMutationOptions<
  ReevaluateLeaseCompletionWebApiResponseDto,
  unknown,
  LeaseWizardWebApiHandler_reevaluateLeaseCompletion_Args
>;

/**
 * reevaluate lease completion after changes to data for cosmos leases
 */
export const useLeaseWizardWebApiHandler_reevaluateLeaseCompletion = ({
  httpClient,
  ...options
}: Omit<LeaseWizardWebApiHandler_reevaluateLeaseCompletion_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseWizardWebApiHandler_reevaluateLeaseCompletion_Args) =>
      LeaseWizardWebApiHandler_reevaluateLeaseCompletion(args.postData, httpClient),
  });
};

export interface LeaseWizardWebApiHandler_submitData_Args {
  postData: SubmitDataRequestDto;
}

export type LeaseWizardWebApiHandler_submitData_Options = UseMutationOptions<
  SubmitDataResponseDto,
  unknown,
  LeaseWizardWebApiHandler_submitData_Args
>;

/**
 * submit data on node
 */
export const useLeaseWizardWebApiHandler_submitData = ({
  httpClient,
  ...options
}: Omit<LeaseWizardWebApiHandler_submitData_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseWizardWebApiHandler_submitData_Args) =>
      LeaseWizardWebApiHandler_submitData(args.postData, httpClient),
  });
};
